import { createAsyncThunk } from '@reduxjs/toolkit';
import { PropertyFeature } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchPropertyFeature,
  FindPropertyFeature,
  GetPropertyFeature,
} from './interface';

export const findPropertyFeature = createAsyncThunk(
  'propertyFeature/findPropertyFeature',
  async (values: FindPropertyFeature, { rejectWithValue }) => {
    try {
      const response = await PropertyFeature.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createPropertyFeature = createAsyncThunk(
  'propertyFeature/createPropertyFeature',
  async (values: CreatePatchPropertyFeature, { rejectWithValue }) => {
    try {
      const response = await PropertyFeature.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPropertyFeature = createAsyncThunk(
  'propertyFeature/patchPropertyFeature',
  async (
    { id, ...values }: CreatePatchPropertyFeature,
    { rejectWithValue }
  ) => {
    try {
      const response = await PropertyFeature.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPropertyFeature = createAsyncThunk(
  'propertyFeature/getPropertyFeature',
  async ({ id }: GetPropertyFeature, { rejectWithValue }) => {
    try {
      const response = await PropertyFeature.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
